export const PaymentGatewayTerminalSaleStatus = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    CANCELED: 'canceled',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type PaymentGatewayTerminalSaleStatus =
    (typeof PaymentGatewayTerminalSaleStatus)[keyof typeof PaymentGatewayTerminalSaleStatus];

export type PaymentGatewayTerminalSaleResult =
    | {
          readonly status: typeof PaymentGatewayTerminalSaleStatus.APPROVED;
          readonly gatewayTransactionId: string;
          readonly approvedAmount: string;
          readonly authorizationCode?: string;
          readonly batchId?: string;
          readonly maskedAccount?: string;
          readonly gatewayToken?: string;
      }
    | {
          readonly status: typeof PaymentGatewayTerminalSaleStatus.DECLINED;
          readonly message: string;
          readonly gatewayTransactionId?: string;
          readonly responseCode?: string;
      }
    | {
          readonly status: typeof PaymentGatewayTerminalSaleStatus.CANCELED;
          readonly message: string;
          readonly gatewayTransactionId?: string;
      }
    | {
          readonly status: typeof PaymentGatewayTerminalSaleStatus.MALFORMED_RESPONSE;
          readonly message: string;
      };
